import { DashboardLayout } from 'components/layout/DashboardLayout';
import { useOnPageExit } from 'hooks/useOnPageExit';
import React, { useState } from 'react';
import { useAlertMessage } from './features/useAlertMessage';
import { useSubmission } from './features/useSubmission';
import ic_small_add from "assets/images/ic_small_add.svg";
import CompanyInfo from './features/CompanyInfo';
import ProductInfo from './features/ProductInfo';
import { Button } from 'components/buttons/Button';
import { Spinner } from 'components/loaders/Spinner';
import { useCustomSelector } from 'hooks';
import "assets/scss/billingPortal/modules/recursiveBillingSetup/quickSetup.scss";
import { isArrayNotEmpty } from 'functions';
import { useHistory } from "react-router-dom";

export default function QuickSetup(props) {
    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);
    const { addAccount_requesting } = useCustomSelector("recursiveBillingSetup")

    // Alert Message
    const {
        alertMessageDisplay, setAlertMsg
    } = useAlertMessage({
        ...props,
        isFormSubmissionAttempted
    });

    const {
        handleSubmission, list, setList, initList
    } = useSubmission({
        ...props,
        isFormSubmissionAttempted, setFormSubmissionStatus,
        setAlertMsg
    })

    // Handle Page Exit
    const history = useHistory();
    const {
        handleHideFormPage,
        pageExitModal
    } = useOnPageExit({
        ...props, history,
        handleSubmission,
        isAnyInputChanged: isArrayNotEmpty(list),
        isEveryInputValid: isArrayNotEmpty(list)
    });

    return (
        <DashboardLayout
            headerTitle={"Quick Product Setup"}
            
            onClose={handleHideFormPage}
            isHeaderCloseIconVisible

            bodyClassName={"recursive-billing-setup__quick-setup"}
            body={(
                <>
                    {/* Page Exit Alert */}
                    {pageExitModal}

                    <div className="quick-setup__sub-header d-flex justify-content-between">
                        {/* Title */}
                        <span className={"sub-header__title"}>Insert Info</span>

                        {/* Action */}
                        <Button
                            className={"sub-header__action"}
                            handleOnClick={handleSubmission}
                            isDecoration_transparentDarkGreyBorder
                        >
                            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                                {addAccount_requesting? (
                                    <Spinner size={0} isLeftMarginOptional />
                                ):(
                                    <img
                                        src={ic_small_add}
                                        className={"action__icon"}
                                    />
                                )}
                                <div className={"action__text"}>
                                    Add
                                </div>
                            </div>
                        </Button>
                    </div>

                    <div className="quick-setup__input-wrapper">
                        {/* Alert Error Messages */}
                        {alertMessageDisplay}
                        
                        {/* Common Inputs */}
                        <div className={"input-wrapper__company-info"}>
                            <CompanyInfo {...props} />
                        </div>

                        {/* Product List */}
                        <div className={"input-wrapper__product-info"}>
                            <ProductInfo {...props} list={list} setList={setList} initList={initList} />
                        </div>
                    </div>
                </>
            )}

            updateParentState_visiblity={props.updateParentState_visiblity}
        />
    );
}